export default function uploadZipFile (bytes, progressValue) {
  return new Promise( async function (resolve, reject) {
    const Unzip = require('zlibjs/bin/unzip.min').Zlib.Unzip
    const Zip = require('zlibjs/bin/zip.min').Zlib.Zip
    const Base64js = require('base64-js')

    const unzip = new Unzip(bytes)
    const zip = new Zip()

    const filenames = unzip.getFilenames()

    await resizeRun(zip, unzip, filenames, Base64js, progressValue)
      .then( (zip2) => {
        const compressData = zip2.compress()
        const blob = new Blob([compressData], { 'type': 'application/zip' })
        resolve(blob)
      })
  })
}

async function resizeImage(base64image) {
  return await new Promise(function (resolve, reject) {
    const MIN_SIZE = 1200
    var canvas = document.createElement('canvas')
    var ctx = canvas.getContext('2d')
    var image = new Image()
    image.crossOrigin = "Anonymous"
    image.src = base64image
    image.onload = function(event){
      var dstWidth, dstHeight
      if (this.width > this.height) {
        dstWidth = MIN_SIZE
        dstHeight = this.height * MIN_SIZE / this.width
      } else {
        dstHeight = MIN_SIZE
        dstWidth = this.width * MIN_SIZE / this.height
      }
      canvas.width = dstWidth
      canvas.height = dstHeight
      ctx.drawImage(this, 0, 0, this.width, this.height, 0, 0, dstWidth, dstHeight)
      resolve(canvas.toDataURL('image/jpeg'))
    }
  })
}

async function resizeRun(zip, unzip, filenames, Base64js, progressValue) {
  const rtn = await new Promise(async function (resolve, reject) {
    const nameCnt = filenames.length
    const total = filenames.length

    for (let index = 0; index < nameCnt;index++) {
      const filename = filenames[index]
      let buf = await Buffer(unzip.decompress(filename))

      if (filename.slice(-3) === 'JPG') {
        const resize = await resizeImage('data:image/jpeg;base64,' + buf.toString('base64'))
        console.log(filename)
        const res = resize.replace('data:image/jpeg;base64,', '')
        buf = Buffer(Base64js.toByteArray(res))
      }
      
      zip.addFile(buf, {
        filename: stringToByteArray(filename)
      })
      progressValue.value = Math.floor((index * 100) / total)
    }
    resolve(zip)
  })
  return rtn
}

function stringToByteArray(str) {
  const array = new (window.Uint8Array !== void 0 ? Uint8Array : Array)(str.length)
  let i
  let il

  for (i = 0, il = str.length; i < il; ++i) {
      array[i] = str.charCodeAt(i) & 0xff
  }

  return array
}
